import { Box, Container, Skeleton } from '@mui/material'
import ButtonActionsBar from 'components/ButtonActionsBar'
import OrderCustomerInfo from 'components/OrderCustomerInfo'
import OrderHeader from 'components/OrderHeader'
import OrderItemsComponent from 'components/OrderItemsComponent'
import POSHeader from 'components/POSHeader'
import PricingSummary from 'components/PricingSummary'
import React from 'react'
import { ThemeProvider } from 'theme/ThemeContext2'
import SplitBillsView from './SplitBillsView'

const OrderDetailsNewContainer = ({ orderDetails, handleBack, onEditCustomer, onStatusChange, updatingStatus, isViewOnly, refetch, isLoading, onOpenSplitModal, onPaySplitBill, onPrintSplitBill, isPayingSplit, onRemoveSplitBill, isRemovingSplit }) => {
    const title = orderDetails?.order_type == 'pos' ? "Take Away Order" : orderDetails?.order_type == "dine_in" ? "Dine-In Order" : orderDetails?.order_type == "delivery" ? "Delivery Order" : orderDetails?.order_type == "collection_point" ? "Collection Point Order" : orderDetails?.order_type == "phone_order" ? "Phone Order" : "Table Booking Order"
    return (
        <ThemeProvider>
            <Box className='order-listing' sx={{ bgcolor: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
                <POSHeader />
                <Container
                    maxWidth={false}
                    disableGutters
                    sx={{
                        // px: { xs: 1, sm: 2, md: 3 },
                        padding: '0px',
                        maxWidth: "1400px",
                        mx: "auto",
                    }}
                >
                    <Box sx={{ padding: '30px 50px' }}>
                        {isLoading ? (
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Skeleton variant="rounded" width={220} height={40} animation="wave" />
                                    <Skeleton variant="rounded" width={300} height={40} animation="wave" />
                                </Box>
                                <Skeleton variant="rounded" width="100%" height={120} animation="wave" />
                                <Skeleton variant="rounded" width="100%" height={240} animation="wave" />
                                <Skeleton variant="rounded" width="100%" height={180} animation="wave" />
                            </Box>
                        ) : (
                            <>
                                <Box sx={{ mb: 3 }} className='d-flex align-items-center justify-content-between'>
                                    <OrderHeader title={title} orderId={orderDetails?.order_id} handleBack={handleBack} textColor={"#1361D5"} />

                                    {!isViewOnly &&
                                        <ButtonActionsBar orderDetails={orderDetails} onOpenSplitModal={onOpenSplitModal} />
                                    }
                                </Box>
                                <Box sx={{ mb: 3 }}>
                                    <OrderCustomerInfo orderDetails={orderDetails} onEditCustomer={onEditCustomer} variant="detailed" onStatusChange={onStatusChange} updatingStatus={updatingStatus} isViewOnly={isViewOnly} />
                                </Box>

                                {/* Render Split Bills cards section if order has split bills */}
                                {orderDetails?.orderSplits && orderDetails.orderSplits.length > 0 && (
                                    <SplitBillsView
                                        orderDetails={orderDetails}
                                        onPaySplitBill={onPaySplitBill}
                                        onPrintSplitBill={onPrintSplitBill}
                                        isPaying={isPayingSplit}
                                        onRemoveSplitBill={onRemoveSplitBill}
                                        isRemoving={isRemovingSplit}
                                    />
                                )}

                                <Box sx={{ mb: 3 }}>
                                    <OrderItemsComponent orderDetails={orderDetails} isViewOnly={isViewOnly} />
                                </Box>

                                <Box>
                                    <PricingSummary orderDetails={orderDetails} isViewOnly={isViewOnly} refetch={refetch} />
                                </Box>
                            </>
                        )}
                    </Box>
                </Container>
            </Box>
        </ThemeProvider>
    )
}

export default OrderDetailsNewContainer
